var map = {
	"./Alfin-Banco.svg": 1119,
	"./BBVA.svg": 7438,
	"./Banco-Falabella.svg": 2463,
	"./Banco-GNB.svg": 3874,
	"./Banco-Ripley.svg": 6150,
	"./Banco-Santander-Peru.svg": 5852,
	"./Bank-of-China.svg": 6905,
	"./Bci-Peru.svg": 5380,
	"./Compartamos.svg": 4567,
	"./Confianza.svg": 714,
	"./Credinka.svg": 5332,
	"./Crediscotia.svg": 511,
	"./Efectiva.svg": 2010,
	"./ICBC-PERU-BANK.svg": 7554,
	"./MiBanco.svg": 6836,
	"./Mitsui-Auto-Finance.svg": 239,
	"./Oh.svg": 4908,
	"./Proempresa.svg": 783,
	"./Qapaq.svg": 835,
	"./agrobanco.svg": 3997,
	"./banbif.svg": 7627,
	"./banco-pichincha.svg": 1224,
	"./bancom.svg": 455,
	"./bcp.svg": 3224,
	"./bdelanacion.svg": 4113,
	"./caja-arequipa.svg": 7015,
	"./caja-cuzco.svg": 3841,
	"./caja-del-santa.svg": 6758,
	"./caja-huancayo.svg": 9439,
	"./caja-ica.svg": 4672,
	"./caja-maynas.svg": 2516,
	"./caja-municipal.svg": 1501,
	"./caja-paita.svg": 4474,
	"./caja-piura.svg": 1352,
	"./caja-sullana.svg": 4592,
	"./caja-tacna.svg": 2710,
	"./caja-trujillo.svg": 7368,
	"./citibank.svg": 6982,
	"./cofide.svg": 1865,
	"./interbank.svg": 435,
	"./mivivienda.svg": 8467,
	"./scotiabank.svg": 3538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9955;